/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_FR_FR: Record<string, string> = {
    ariaAnnounceChart: 'graphique, ${seriesCount}[number] séries',
    ariaAnnounceFlowProportionLink: 'lien ${index} de ${count}, de ${from} à ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'nœud ${index} de ${count}, ${description}',
    ariaAnnounceGaugeChart: 'graphique en jauge, ${caption}',
    ariaAnnounceHierarchyChart: 'graphique hiérarchique, ${caption}',
    ariaAnnounceHierarchyDatum: 'niveau ${level}[number], ${count}[number] enfants, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Appuyez sur Espace ou Entrée pour basculer la visibilité',
    ariaLabelAddHorizontalLine: 'Ajouter une ligne horizontale',
    ariaLabelAnnotationOptionsToolbar: "Options d'annotation",
    ariaLabelAnnotationSettingsDialog: "Paramètres d'annotation",
    ariaLabelColorPicker: 'Sélecteur de couleur',
    ariaLabelFinancialCharts: 'Graphiques financiers',
    ariaLabelLegend: 'Légende',
    ariaLabelLegendItem: '${label}, Élément de légende ${index}[number] sur ${count}[number]',
    ariaLabelLegendItemUnknown: 'Élément de légende inconnu',
    ariaLabelLegendPageNext: 'Page de légende suivante',
    ariaLabelLegendPagePrevious: 'Page précédente de la légende',
    ariaLabelLegendPagination: 'Pagination des légendes',
    ariaLabelNavigator: 'Navigateur',
    ariaLabelNavigatorMaximum: 'Maximum',
    ariaLabelNavigatorMinimum: 'Minimum',
    ariaLabelNavigatorRange: 'Plage',
    ariaLabelRangesToolbar: 'Plages',
    ariaLabelSettingsTabBar: 'Paramètres',
    ariaLabelZoomToolbar: 'Zoom',
    ariaValuePanRange: '${min}[percent0to2dp] à ${max}[percent0to2dp]',
    contextMenuDownload: 'Télécharger',
    contextMenuPanToCursor: "Panoramique jusqu'ici",
    contextMenuToggleOtherSeries: 'Basculer les autres séries',
    contextMenuToggleSeriesVisibility: 'Basculer la visibilité',
    contextMenuZoomToCursor: 'Zoomer ici',
    dialogHeaderChannel: 'Canal',
    dialogHeaderDatePriceRange: 'Date et prix',
    dialogHeaderDateRange: 'Plage de dates',
    dialogHeaderFibonacciRange: 'Retracement Fib',
    dialogHeaderLine: 'Ligne',
    dialogHeaderPriceRange: 'Plage de prix',
    dialogHeaderText: 'Texte',
    dialogInputAlign: 'Alignement',
    dialogInputColorPicker: 'Couleur',
    dialogInputColorPickerAltText: 'Couleur de texte',
    dialogInputExtendAbove: 'Étendre au-dessus',
    dialogInputExtendBelow: 'Étendre vers le bas',
    dialogInputExtendChannelEnd: 'Prolonger la fin du canal',
    dialogInputExtendChannelStart: 'Étendre le début du canal',
    dialogInputExtendLeft: 'Étendre à gauche',
    dialogInputExtendLineEnd: 'Étendre la fin de la ligne',
    dialogInputExtendLineStart: 'Étendre le début de la ligne',
    dialogInputExtendRight: 'Étendre vers la droite',
    dialogInputFibonacciBands: 'Bandes',
    dialogInputFibonacciBandsAltText: 'Bandes de Fibonacci',
    dialogInputFillColorPicker: 'Remplissage',
    dialogInputFillColorPickerAltText: 'Couleur de remplissage',
    dialogInputFontSize: 'Taille',
    dialogInputFontSizeAltText: 'Taille de police',
    dialogInputLineStyle: 'Tiret',
    dialogInputPosition: 'Position',
    dialogInputReverse: 'Inverser',
    dialogInputShowFill: 'Afficher le remplissage',
    dialogInputStrokeWidth: 'Épaisseur',
    dialogInputStrokeWidthAltText: 'Épaisseur de la ligne',
    iconAltTextAlignCenter: 'Centrer',
    iconAltTextAlignLeft: 'Gauche',
    iconAltTextAlignRight: 'Droite',
    iconAltTextClose: 'Fermer',
    iconAltTextLineStyleDashed: 'Longue-tirets',
    iconAltTextLineStyleDotted: 'Tirets courts',
    iconAltTextLineStyleSolid: 'Solide',
    iconAltTextPositionBottom: 'Bas',
    iconAltTextPositionCenter: 'Centre',
    iconAltTextPositionTop: 'Haut',
    inputTextareaPlaceholder: 'Ajouter du texte',
    measurerDateRangeBars: '${value}[number] barres',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Vol ${value}',
    overlayLoadingData: 'Chargement des données...',
    overlayNoData: 'Aucune donnée à afficher',
    overlayNoVisibleSeries: 'Aucune série visible',
    overlayUnsupportedBrowser: 'Version de navigateur incompatible. Veuillez mettre à jour votre navigateur.',
    seriesHistogramTooltipCount: '${yName} (compte)',
    seriesHistogramTooltipFrequency: 'Fréquence',
    seriesHistogramTooltipMean: '${yName} (moyenne)',
    seriesHistogramTooltipSum: '${yName} (somme)',
    toolbarAnnotationsArrow: 'Flèche',
    toolbarAnnotationsArrowDown: 'Flèche Bas',
    toolbarAnnotationsArrowUp: 'Flèche Haut',
    toolbarAnnotationsCallout: 'Bulles',
    toolbarAnnotationsClearAll: 'Tout Effacer',
    toolbarAnnotationsComment: 'Commentaire',
    toolbarAnnotationsDatePriceRange: 'Date et prix',
    toolbarAnnotationsDateRange: 'Plage de dates',
    toolbarAnnotationsDelete: 'Supprimer',
    toolbarAnnotationsDisjointChannel: 'Canal disjoint',
    toolbarAnnotationsDragHandle: "Faites glisser la barre d'outils",
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Retrait Fib',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Fib tendance basée',
    toolbarAnnotationsFillColor: 'Couleur de remplissage',
    toolbarAnnotationsHorizontalLine: 'Ligne Horizontale',
    toolbarAnnotationsLineAnnotations: 'Lignes de tendance',
    toolbarAnnotationsLineColor: 'Couleur de la ligne',
    toolbarAnnotationsLineStrokeWidth: 'Épaisseur du trait de la ligne',
    toolbarAnnotationsLineStyle: 'Style de ligne',
    toolbarAnnotationsLock: 'Verrouiller',
    toolbarAnnotationsMeasurerAnnotations: '"Mesureurs"',
    toolbarAnnotationsNote: 'Note',
    toolbarAnnotationsParallelChannel: 'Canal parallèle',
    toolbarAnnotationsPriceRange: 'Plage de prix',
    toolbarAnnotationsQuickDatePriceRange: 'Mesurer',
    toolbarAnnotationsSettings: 'Paramètres',
    toolbarAnnotationsShapeAnnotations: 'Flèches',
    toolbarAnnotationsText: 'Texte',
    toolbarAnnotationsTextAnnotations: 'Annotations de texte',
    toolbarAnnotationsTextColor: 'Couleur du texte',
    toolbarAnnotationsTextSize: 'Taille du texte',
    toolbarAnnotationsTrendLine: 'Tendance',
    toolbarAnnotationsUnlock: 'Déverrouiller',
    toolbarAnnotationsVerticalLine: 'Ligne verticale',
    toolbarRange1Month: '1M',
    toolbarRange1MonthAria: '1 mois',
    toolbarRange1Year: '1A',
    toolbarRange1YearAria: '1 an',
    toolbarRange3Months: '3M',
    toolbarRange3MonthsAria: '3 mois',
    toolbarRange6Months: '6M',
    toolbarRange6MonthsAria: '6 mois',
    toolbarRangeAll: 'Tous',
    toolbarRangeAllAria: 'Tous',
    toolbarRangeYearToDate: "Depuis le début de l'année",
    toolbarRangeYearToDateAria: 'Année à ce jour',
    toolbarSeriesTypeCandles: 'Bougies',
    toolbarSeriesTypeDropdown: 'Type de graphique',
    toolbarSeriesTypeHighLow: 'Haut Bas',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Bougies creuses',
    toolbarSeriesTypeLine: 'Ligne',
    toolbarSeriesTypeLineWithMarkers: 'Ligne avec Marqueurs',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Ligne en étapes',
    toolbarZoomPanEnd: "Déplacer jusqu'à la fin",
    toolbarZoomPanLeft: 'Déplacer vers la gauche',
    toolbarZoomPanRight: 'Déplacer vers la droite',
    toolbarZoomPanStart: 'Déplacer au début',
    toolbarZoomReset: 'Réinitialiser le zoom',
    toolbarZoomZoomIn: 'Agrandir',
    toolbarZoomZoomOut: 'Dézoomer',
    tooltipPaginationStatus: '${index}[number] sur ${count}[number]',
};
